/**
 * SUF Store
 *
 * Zod schemas, types, constants, and helpers for the Sign-Up Flow (SUF) store.
 * Used at the hydration layer to apply defaults, strip unknown fields,
 * and safely handle type mismatches from persisted state.
 *
 * RULES:
 * - Do NOT import from other workspace libraries. This lib must remain self-contained.
 * - If you need a type from another lib, add a copy of it to types/enums.ts or schemas/primitives.ts.
 */

// Types — enums, field keys, derived types
export * from "./lib/types/enums";
export * from "./lib/types/field-keys";
export * from "./lib/types/cat-field-name";

// Constants — defaults, mapping tables
export * from "./lib/constants/defaults";
export * from "./lib/constants/subscription-normalisation.constants";
export * from "./lib/constants/ab-tests";

// Helpers — normalisation & transform functions
export * from "./lib/helpers/subscription-normalisation";
export * from "./lib/helpers/enrich-zod-issues";
export * from "./lib/helpers/legacy-cat-fitness";

// Schemas — Zod schema definitions
export * from "./lib/schemas/primitives";
export * from "./lib/schemas/cat-form-data.schema";
export * from "./lib/schemas/user-form-data.schema";
export * from "./lib/schemas/delivery-data.schema";
export * from "./lib/schemas/subscription-data.schema";
export * from "./lib/schemas/view-state.schema";
export * from "./lib/schemas/signup-flow-store.schema";
export * from "./lib/schemas/direct-sales-store.schema";
export * from "./lib/schemas/error-store.schema";
